
<template>
  <div id="page_redemptions" class="column p0 services minH100">
    <div class="cointainer_lg column combo_1">
      <div class="column p0">
        <h1 class="fat" style="padding: 0.5rem 0">
          {{ $tc("msg.services", 1) }}
        </h1>
      </div>
      <div class="tal_r button_switch_column">
        <div class="tal_l p0_b">
          <div
            style="display: flex; align-items: center"
            v-if="mode == 'redeem' && authorized"
          >
            <div
              class="icon_class_2"
              v-html="iconSets.blu_redeem_icon_blu"
            ></div>
            <h1
              class="component_title_md fat m0_b m9_l main_blue_dk_fill"
              style="font-size: 1.8rem"
            >
              {{ $tc("msg.redemption", 1) }}
            </h1>
          </div>

          <div
            style="display: flex; align-items: center"
            v-if="mode == 'withdraw' && authorized"
          >
            <div
              class="icon_class_2"
              v-html="iconSets.blu_withdraw_icon_blu"
            ></div>
            <h1
              class="component_title_md fat m0_b m9_l main_blue_dk_fill"
              style="font-size: 1.8rem"
            >
              {{ $tc("msg.withdrawal") }}
            </h1>
          </div>

          <div
            style="display: flex; align-items: center"
            v-if="mode == 'internal' && authorized"
          >
            <div class="icon_class_2" v-html="iconSets.internal_icon_blu"></div>
            <h1
              class="component_title_md fat m0_b m9_l main_blue_dk_fill"
              style="font-size: 1.8rem"
            >
              {{ $tc("msg.internal_transfer", 1) }}
            </h1>
          </div>

          <div
            style="display: flex; align-items: center"
            v-if="mode == 'deposit' && authorized"
          >
            <div
              class="icon_class_2"
              v-html="iconSets.blu_deposit_icon_blue"
            ></div>
            <h1
              class="component_title_md fat m0_b m9_l main_blue_dk_fill"
              style="font-size: 1.8rem"
            >
              {{ $tc("msg.deposit", 1) }}
            </h1>
          </div>
        </div>
      </div>

      <div class="p0_t">
        <h2
          v-html="$t('msg.redemption_sub')"
          v-if="mode == 'redeem' && authorized"
          class="fs_small_wm"
        ></h2>

        <div
          style="font-weight: 500; padding-left: 20px; margin-top: 10px"
          v-if="mode == 'redeem' && authorized"
        >
          <ul style="list-style-type: disc" class="fat">
            <li>{{ $t("msg.redemption_sub_one") }}</li>
            <li>{{ $t("msg.redemption_sub_two") }}</li>
            <li>{{ $t("msg.redemption_sub_three") }}</li>
          </ul>
        </div>

        <div v-if="mode == 'internal' && authorized" class="fs_small_wm">
          <h2 v-html="$t('msg.internal_sub')"></h2>
        </div>

        <div
          v-if="(mode == 'deposit' || mode == 'withdraw') && authorized"
          class="deposit_actions"
        >
          <button
            @click="toogleCoin('blue')"
            :class="selectedBlue && 'selectedBlue'"
          >
            <img
              v-if="!selectedBlue"
              src="../../assets/images/blue_icon.svg"
              alt="blue_token"
            />
            <img
              v-else
              src="../../assets/images/blue_white_outline_logo.png"
              alt="blue_token"
            />
            <span>BLUE</span>
          </button>
          <button
            @click="toogleCoin('usdt')"
            :class="!selectedBlue && 'selectedEther'"
          >
            <img
              src="../../assets/images/coins/ico-crypto-usdt.svg"
              alt="blue_token"
            />
            <span>USDT</span>
          </button>
        </div>

        <div v-if="mode == 'withdraw' && authorized" class="fs_small_wm">
          <h2 v-if="selectedBlue" v-html="$t('msg.withdraw_sub')"></h2>
          <h2 v-else v-html="$t('msg.withdraw_sub_usdt')"></h2>
        </div>

        <div v-if="mode == 'deposit' && authorized" class="fs_small_wm">
          <h2 v-html="$t('msg.deposit_sub', { coin })"></h2>
        </div>

        <div v-if="!authorized">
          <h2 v-html="$t('msg.info_2fa_tip')"></h2>
        </div>
      </div>
      <div class="page_redemptions_body redeem_grid button_switch_container">
        <div class="i2 p0">
          <div style="padding-bottom: 1rem">
            <redemption-balance
              v-if="authorized"
              :selectedBlue="selectedBlue"
            ></redemption-balance>
          </div>
          <div
            class="towFA_instructions"
            v-if="authorized && mode == 'withdraw' && selectedBlue"
          >
            <div
              v-html="$t('msg.tutorial_tittle_withdraw')"
              style="cursor: pointer; font-size: 1.1rem; margin-bottom: 1rem"
              @click="() => this.toggleTutorial()"
            ></div>

            <div
              class="font-wb-tutorial"
              style="max-width: 400px; margin-bottom: 1rem"
              v-if="this.tutorial || this.isWeb"
            >
              <div v-html="$t('msg.tutorial_withdraw')"></div>

              <div
                class="copy-clip pointer"
                v-clipboard:copy="$t('msg.contract_address')"
                v-clipboard:success="onCopySuccess"
                v-clipboard:error="onCopyError"
                style="
                  margin-top: 10px;
                  margin-bottom: 10px;
                  display: flex;
                  background: #424b7d;
                  padding: 5px;
                  border-radius: 8px;
                  justify-content: center;
                "
              >
                <div
                  style="color: white; line-break: anywhere"
                  class="font-address"
                >
                  {{ $t("msg.contract_address") }}
                </div>
                <span
                  v-html="iconSets.copy_white"
                  class="icon_class_15"
                  style="margin-left: 10px"
                ></span>
              </div>

              <div v-html="$t('msg.tutorial_withdraw_pt2')"></div>
            </div>
          </div>

          <div
            class="towFA_instructions"
            v-if="authorized && mode == 'deposit'"
          >
            <div
              v-html="$t('msg.tutorial_tittle', { coin: howDepositCoin })"
              style="cursor: pointer; font-size: 1.2rem"
              @click="() => this.toggleTutorial()"
            ></div>

            <div
              class="font-wb-tutorial"
              style="max-width: 400px"
              v-html="$t('msg.tutorial_deposit')"
              v-if="(this.tutorial || this.isWeb) && selectedBlue"
            ></div>

            <div
              class="font-wb-tutorial"
              style="max-width: 400px"
              v-html="$t('msg.tutorial_deposit_usdt')"
              v-if="(this.tutorial || this.isWeb) && !selectedBlue"
            ></div>
          </div>

          <div class="towFA_instructions column" v-if="!authorized">
            <div class v-html="$t('msg.reedeem_2fa_text')"></div>
          </div>
        </div>

        <div class="i1 p0">
          <redemption-main
            @updateOptStatus="getOtpStatus"
            v-if="mode == 'redeem'"
          ></redemption-main>
          <withdraw-main
            @updateOptStatus="getOtpStatus"
            :selectedBlue="selectedBlue"
            :step="stepWithdraw"
            v-if="mode == 'withdraw'"
          ></withdraw-main>
          <deposit-main
            @updateOptStatus="getOtpStatus"
            :selectedBlue="selectedBlue"
            v-if="mode == 'deposit'"
          >
          </deposit-main>
          <internal-main
            :openOrder="openOrder"
            @updateOptStatus="getOtpStatus"
            v-if="mode == 'internal'"
            @cancelOpenWithdraws="(id) => cancelOpenWithdraws(id)"
          ></internal-main>
          <failed-table
            :failedOrders="this.internalArray"
            v-if="this.internalArray && authorized && this.mode != 'deposit'"
            @continueTransaction="(el) => continueTransaction(el)"
            @cancelTransaction="(el) => cancelOpenWithdraws(el)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import WithdrawMain from "../../components/private/services/WithdrawMain";
import DepositMain from "../../components/private/services/DepositMain";
import RedemptionMain from "../../components/private/services/RedemptionMain";
import RedemptionBalance from "../../components/private/services/RedemptionBalance";
import InternalMain from "../../components/private/services/InternalMain";
import FailedTable from "../../components/private/services/FailedTable";
import { mapGetters } from "vuex";

export default {
  created() {
    this.getOtpStatus();
    this.$store.dispatch("updateBluAccount");

    this.getWithdraws();
    this.getRedeems();

    this.getWithdrawsTotal();

    this.mode = this.$route.params.arg;
    this.type = this.$route.params.arg;

    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },
  mounted() {},
  data: () => ({
    authorized: false,
    authorized: false,
    mode: "withdraw",
    type: "withdraw",
    withdraws: "",
    redeems: "",
    failedOrders: "",
    internals: "",
    internalArray: "",
    openOrder: "",
    tutorial: false,
    isWeb: false,
    selectedBlue: true,
    coin: "BLUE",
    howDepositCoin: "Blue",
    stepWithdraw: 3,
  }),
  components: {
    RedemptionMain,
    RedemptionBalance,
    WithdrawMain,
    FailedTable,
    InternalMain,
    DepositMain,
  },
  methods: {
    toggleTutorial() {
      this.tutorial = !this.tutorial;
    },

    checkIfMobile() {
      let w = window,
        x = w.innerWidth;

      if (x > 1200) {
        console.log("aqqqqqq");
        this.isWeb = true;
      } else {
        this.isWeb = false;
      }
    },

    continueTransaction(el) {
      this.openOrder = el;
    },

    async getOtpStatus() {
      let resp = await this.$store.dispatch("getOtpStatus");
      this.authorized = resp.data;
    },

    setMode(selectedMode) {
      this.mode = selectedMode;
    },

    async getRedeems() {
      let resp = await this.$store.dispatch("getTransactionsByType", "redeem");
      if (resp.status == 200) {
        this.redeems = resp.data;
      } else {
        console.log("no withdraws");
      }
    },

    async getWithdraws() {
      let resp = await this.$store.dispatch(
        "getTransactionsByType",
        "withdraw"
      );
      if (resp.status == 200) {
        this.withdraws = resp.data;
      } else {
        console.log("no withdraws");
      }
    },

    async getWithdrawsTotal() {
      let resp = await this.$store.dispatch("getWithdraws");
      if (resp.status == 200) {
        this.internals = resp.data;

        this.iternalTransfers();
      } else {
        console.log("no withdraws");
      }
    },

    iternalTransfers() {
      // let array = this.internals.concat(this.redeems);
      let array = this.internals;
      let internalArray = [];

      array.forEach((element) => {
        if (element.status == "new") {
          internalArray.push(element);
        }
      });

      this.internalArray = internalArray;
    },

    checkRunningWithdraws() {
      let withdraws = this.withdraws;
      let openWithdraws = [];

      for (let i in withdraws) {
        if (withdraws[i].status == "new") {
          openWithdraws.push(withdraws[i]);
        }
      }

      if (openWithdraws.length > 0) {
        for (let i in openWithdraws) {
          this.cancelOpenWithdraws(openWithdraws[i].id);
        }
      }
    },

    checkFailedOrder() {
      let orderArray = this.withdraws.concat(this.redeems);

      let failed = [];
      for (let i in orderArray) {
        if (orderArray[i].status == "failed") {
          failed.push(orderArray[i]);
        }
      }
      this.failedOrders = failed.concat(this.internalArray);
    },

    async cancelOpenWithdraws(id) {
      let body = {
        e2faCode: "000000",
        id: id,
        pinCode: "000000",
      };

      for (let i = 0; i < 6; i++) {
        try {
          await this.$store.dispatch("putWithdrawConfirm", body);
        } catch (e) {
          console.log(e);
        }
      }

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    },

    toogleCoin(coin) {
      if (this.stepWithdraw == 4) {
        this.stepWithdraw = 3;
      }

      if (coin == "blue") {
        this.selectedBlue = true;
        this.coin = "BLUE";
        this.howDepositCoin = "Blue";
      } else {
        this.selectedBlue = false;
        this.coin = "USDT";
        this.howDepositCoin = "Tether (USDT)";
      }
    },
  },
  watch: {
    withdraws: function () {
      // this.checkRunningWithdraws();
      // this.checkFailedOrder(this.withdraws);

      this.iternalTransfers();
    },

    redeems: function () {
      this.checkFailedOrder();
    },

    $route: function () {
      this.mode = this.$route.params.arg;
      this.type = this.$route.params.arg;
    },

    mode(newMode, oldMode) {
      if (newMode !== oldMode) {
        this.selectedBlue = true;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/private/Services.vue